import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as SettingsActions from './settings.action';
import { SettingsService } from './settings.service';
import * as SettingsModels from '../../models/settings/settings';
import { BannerService } from '../../shared/services/banner.service';
import { HelperService } from '../helper/helper.service';
import * as Models from "../../models/commonModels";

export interface SettingsStateModel {
  Settings: Models.Response<SettingsModels.SettingsPreview>;
}

@State<SettingsStateModel>({
  name: 'settingsState',
  defaults: {
    Settings: null,
  }
})

@Injectable()
export class SettingsState {

  constructor(
    private helperService: HelperService,
    private invoiceService: SettingsService,
    private bannerService: BannerService
  ) { }

  @Selector()
  static Settings(state: SettingsStateModel) {
    return state.Settings;
  }


  @Action(SettingsActions.Get)
  get(
    context: StateContext<SettingsStateModel>,
    action: SettingsActions.Get
  ) {
    context.setState(
      patch({
        Settings: null
      })
    );

    this.invoiceService.get().subscribe(
      (data) => {
        if (data.Success) {
          context.setState(
            patch({
              Settings: data,
            })
          );
        }
      },
      (error) => {
        this.bannerService.error("Błąd pobierania konfiguracji.");
        this.helperService.SaveException("SettingsActions.Get", error);
      }
    );
  }

}

